import React, {Component} from 'react'
import {connect}          from 'react-redux'
import SplashView       from '../components/SplashView'


const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

class Splash extends Component {
  state = { error: null }

  constructor(props) {
    super(props)
    this.submit     = this.submit.bind(this)
    this.changeText = this.changeText.bind(this)
  }

  changeText() {
    this.setState({error: null})
  }

  submit(e) {
    e.preventDefault()

    const form  = e.target
    const email = form.email.value
    if( !email || !email.match(regex) ) {
      this.setState({error: 'Email Invalid'})
      return;
    }

    if( form.b_name.value || form.b_email.value || form.b_comment.value ) {
      return this.setState({success: true})
    }

    window.jQuery.ajax({
      type: 'get',
      url:  `https://gamejamla.us18.list-manage.com/subscribe/post-json?u=d86c051b4d65aa09e9fa6b8ba&id=3b1d1c9817&c=?&EMAIL=${email}`,
      dataType: 'json',
      error: (err) => { this.setState({error: JSON.stringify(err)}) },
      success: (data) => { this.setState({success: true})}
    })
  }

  render() {
    return (
      <SplashView {...this.props}
        changeText={this.changeText}
        submit={this.submit}
        success={this.state.success}
        error={this.state.error}/>
    )
  }
}

function mapStateToProps(state) {
  return {

  }
}

function mapDispatchToProps(dispatch) {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Splash)



// WEBPACK FOOTER //
// ./src/containers/Splash.js